import { graphql } from '../gql';

export const getFeatureFlag = graphql(`
  query GetFeatureFlagState($flag: String!) {
    getFeatureFlag(input: { name: $flag }) {
      featureFlag {
        enabled
        name
      }
      error {
        message
        code
      }
    }
  }
`);
